import clsx from "clsx";
import type React from "react";
import type { PropsWithChildren } from "react";
import styles from "./heading.module.scss";

type Variant = "xlarge" | "large" | "medium" | "small" | "xsmall" | "2xsmall";

type TextAsProp = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface TextProps
  extends PropsWithChildren<React.HTMLAttributes<HTMLElement>> {
  as?: TextAsProp;
  variant: Variant;
}

export const Heading: React.FC<TextProps> = ({
  as = "h1",
  variant,
  children,
  ...props
}) => {
  const Component = as;
  const className = clsx(props.className, styles[variant]);

  return (
    <Component {...props} className={className}>
      {children}
    </Component>
  );
};
